const s = {
  name: "Djset",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M25,5v8h2V5H25z"/>
		<path class="st0" d="M21,13V8h2v5H21z"/>
		<path class="st0" d="M29,8v5h2V8H29z"/>
		<path class="st0" d="M33,13V5h2v8H33z"/>
		<path class="st0" d="M12,20c-4.4,0-8,3.6-8,8s3.6,8,8,8c4.4,0,8-3.6,8-8S16.4,20,12,20z M6,28c0-3.3,2.7-6,6-6
			c1.3,0,2.5,0.4,3.5,1.1l-4.2,4.2l1.4,1.4l4.2-4.2c0.7,1,1.1,2.2,1.1,3.5c0,3.3-2.7,6-6,6C8.7,34,6,31.3,6,28z"/>
		<path class="st0" d="M22,29v-6h2v-3h2v3h2v6h-2v7h-2v-7H22z M24,27h2v-2h-2V27z"/>
		<path class="st0" d="M34,20v7h2v6h-2v3h-2v-3h-2v-6h2v-7H34z M32,29v2h2v-2H32z"/>
		<path class="st0" d="M3,0C1.3,0,0,1.3,0,3v34c0,1.7,1.3,3,3,3h34c1.7,0,3-1.3,3-3V3c0-1.7-1.3-3-3-3H3z M2,3c0-0.6,0.4-1,1-1h13v2
			H2V3z M2,6h14v2H2V6z M2,12v-2h14v2H2z M2,14h14v2H2V14z M18,16V2h19c0.6,0,1,0.4,1,1v13H18z M2,18h36v19c0,0.6-0.4,1-1,1H3
			c-0.6,0-1-0.4-1-1V18z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Djset
};
